module.exports = __webpack_public_path__ + "static/img/13.52d85f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/13.jpg
// module id = HJ+b
// module chunks = 0